import { Component } from '@angular/core';
import { filterPageTypes } from 'src/app/store/filters.era';
import { PAGE_NAME } from 'globals/store/permissions.data';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { TaskTableComponent } from './task-table.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'my-task-table-page',
    template: `<task-table [isMyTasks]="true" [page_name]="pageName" [traceName]="traceName" [filterPage]="filterPage"></task-table>`,
    styleUrls: ['../../page.pass-through.scss'],
    standalone: true,
    providers: [DatePipe],
    imports: [TaskTableComponent]
})
export class MyTaskTablePageComponent {
    filterPage = filterPageTypes.myTasks;
    pageName = PAGE_NAME.my_tasks_table
    traceName = traceNames.viewMyTasksTable
}

